import {
  type Brand,
  type Country,
  brandAndCountryFromZone,
} from '@seek/audience-zones';
import { useSelector } from 'react-redux';
import { selectZone } from 'src/store/selectors';

export const useBrandAndCountry = () => {
  const zone = useSelector(selectZone);
  const [brand, country] = brandAndCountryFromZone(zone) as [Brand, Country];

  return { brand, country };
};
